// components/SbcConfirmation.jsx — the explicit eligibility confirmation for the small business
// corporation (SBC) basis (kailux-fixes-log.md §108). Shared by the Tax basis card and the tax
// provision card so the wording and the rule are identical in both.
//
// KaiLux never decides eligibility (a trial balance cannot show it). This block lists the
// conditions as a SUMMARY and asks the preparer to confirm, for THIS year of assessment. The
// confirmation is never pre-ticked, and the optional `hint` ("last confirmed … for FY2025") only
// reminds — it does not tick, select or decide anything.
import { T, alpha } from '../theme/theme'

export default function SbcConfirmation({ conditions = [], confirmed, onChange, hint = null, idPrefix = 'sbc' }) {
  const id = `${idPrefix}-confirm`
  return (
    <div data-testid="sbc-confirmation" style={{ marginTop: '10px' }}>
      {hint?.financial_year && (
        <div data-testid="sbc-hint" role="note" style={{ fontSize: '12px', color: T.yl, marginBottom: '8px', lineHeight: 1.5 }}>
          Last confirmed as a small business corporation for FY{hint.financial_year}. That does not carry over:
          eligibility is checked for every year of assessment, so please confirm again for this one.
        </div>
      )}
      <div style={{ fontSize: '12px', color: T.lt, marginBottom: '6px' }}>
        To use the small business corporation basis, the company must meet these conditions for this year of assessment:
      </div>
      <ul data-testid="sbc-conditions" style={{ margin: '0 0 8px', paddingLeft: '18px', fontSize: '12px', color: T.lt, lineHeight: 1.5 }}>
        {conditions.map((c, i) => <li key={i}>{c}</li>)}
      </ul>
      <div style={{ fontSize: '11px', color: T.mt, marginBottom: '8px' }}>
        A summary only. The authority is section 12E of the Income Tax Act and SARS guidance, and you are responsible for the judgement.
        KaiLux cannot see these facts in a trial balance.
      </div>
      <label htmlFor={id} style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', fontSize: '13px', color: T.tx,
        background: alpha(T.am, 0.08), border: `1px solid ${alpha(T.am, 0.3)}`, borderRadius: '8px', padding: '8px 10px', cursor: 'pointer' }}>
        <input id={id} type="checkbox" checked={!!confirmed} onChange={(e) => onChange(e.target.checked)} style={{ marginTop: '3px' }} />
        <span>I confirm this company qualifies as a small business corporation for this year of assessment.</span>
      </label>
    </div>
  )
}
